
import LandAnimateOverSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/land-animate-over-symbol-behaviour.ts";
import Contract from "slotworks/utils/contracts/contract";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import graphicsManager from "slotworks/graphics/graphics-manager";
import Timer from "slotworks/utils/timer";
import { FadeIn } from "slotworks/graphics/animation/base-animations";

export default class MCSymbolBorderAnimationBehaviour extends LandAnimateOverSymbolBehaviour {

    public static masterAnimation: AnimatedSprite;
    public behaviourName: string = "MCSymbolBorderAnimationBehaviour";

    public land(): Contract<void> {

        Timer.setTimeout(() => {
            super.land().execute();

            if (!MCSymbolBorderAnimationBehaviour.masterAnimation) {
                this.setupMasterAnimation();
            }

            this.animation.currentFrame = MCSymbolBorderAnimationBehaviour.masterAnimation.currentFrame;

            FadeIn(this.animation, 100).execute();
        }, 250);

        return Contract.empty();
    }

    protected setupMasterAnimation() {
        const masterAnimation = graphicsManager.createAnimation("bonus_symbol_frame");
        masterAnimation.play();
        masterAnimation.loop = true;
        masterAnimation.visible = false;
        MCSymbolBorderAnimationBehaviour.masterAnimation = masterAnimation;
    }
}
